export function getAlbumFolder(albumId: number): string | undefined {
  for (let x = 500; x < 10000; x += 500) {
    const min = x - 499;
    if (albumId <= x) {
      return `${min}_${x}`;
    }
  }
  return undefined;
}

export function getAlbumArt(albumId: string | number): string {
  const id = typeof albumId === "string" ? parseInt(albumId) : albumId;
  if (!id || isNaN(id) || id <= 0) return "";

  const folderPath = getAlbumFolder(id);
  if (folderPath) {
    return `https://musictierlist.com/AlbumImages/${folderPath}/Album_${id}.jpg`;
  }
  return `https://musictierlist.com/AlbumImages/Album_${id}.jpg`;
}
